import * as ActionTypes from '../constants/ActionTypes';

const initialState = {
	subscription: null,
	loading: false,
	loadingSubmit: false,
	loadingCancel: false,

	//	Subscription Receipt
	total: 0,
	page: 1,
	limit: 10,
	count: 0,
	invoices: [],
	loadingReceipts: false
};

export default function settingPageReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_ACTIVE_SUBSCRIPTION_REQUEST:
		case ActionTypes.GET_ACTIVE_SUBSCRIPTION_ERROR:
		case ActionTypes.GET_ACTIVE_SUBSCRIPTION_SUCCESS:
		case ActionTypes.CANCEL_SUBSCRIPTION_REQUEST:
		case ActionTypes.CANCEL_SUBSCRIPTION_ERROR:
		case ActionTypes.CANCEL_SUBSCRIPTION_SUCCESS:
		case ActionTypes.GET_SUBSCRIPTION_RECEIPTS_REQUEST:
		case ActionTypes.GET_SUBSCRIPTION_RECEIPTS_ERROR:
		case ActionTypes.GET_SUBSCRIPTION_RECEIPTS_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_BILLING_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_BILLING_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
